const map = {
	"./2010/Posters/Index.vue": 39030,
	"./2011/Posters/Index.vue": 54329,
	"./2012/Posters/Index.vue": 27546,
	"./2013/Posters/Index.vue": 84497,
	"./2014/Posters/Index.vue": 70613,
	"./2015/Posters/Index.vue": 19820,
	"./2016/Posters/Index.vue": 91816,
	"./2017/Posters/Index.vue": 48991,
	"./2018/Posters/Index.vue": 30552,
	"./2019/Posters/Index.vue": 61982,
	"./2021/Posters/Index.vue": 17024,
	"./2022/Posters/Index.vue": 226,
	"./2023/Posters/Index.vue": 88757,
	"./2024/Posters/Index.vue": 26186,
	"./2025/Posters/Index.vue": 40554,
	"./2026/Posters/Index.vue": 32363
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55795;